import { useLocation } from "@reach/router"
import axios from "axios"
import { Link } from "gatsby"
import React, { memo, useCallback, useEffect, useMemo, useState } from "react"
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap"
import { Helmet } from "react-helmet"
import { Link as ScrollLink } from "react-scroll"
import { SlideDown } from "react-slidedown"
import "react-slidedown/lib/slidedown.css"
import LogoDark from "../assets/svgs/dark-logo-dsk.svg"
import ArrowDownMob from "../assets/svgs/nav-arrowdown-mob.svg"
import AiStarWhite from "../assets/svgs/navigation/ai-star-white.svg"
import AiStar from "../assets/svgs/navigation/ai-star.svg"
import useNavbarQuery from "../hooks/queries/useNavbarQuery"
import "../styles/double-navbar.scss"
import Buttons from "./common/button"
import SVGIcon from "./common/SVGIcon"
import NavbarDropdown from "./NavbarDropdown"
import NavbarDropdownMobile from "./NavbarDropdownMobile"
import HelloBar from "./webinar/hello-bar"

function DoubleNavbar(props) {
  const { navType } = props

  const data = useNavbarQuery()
  const [isHelloBarOneVisible, setIsHelloBarOneVisible] = useState(false)
  const [isHelloBarTwoVisible, setIsHelloBarTwoVisible] = useState(false)

  const smallDropdowns = ["Solutions", "Pricing"]

  const [isScrolledDown, setScrolledDown] = useState(false)

  const [hideLogo, setHideLogo] = useState(false)

  const [isScrollMob, setScrollMob] = useState(false)

  const [isNavOpen, setIsNavOpen] = useState(false)

  const [showDropdown, setShowDropdown] = useState(false)

  const [currentNav, setCurrentNav] = useState("")

  const [showDropdownMob, setShowDropdownMob] = useState(false)

  const [currentNavMob, setCurrentNavMob] = useState("")

  const [dropDownLinks, setDropDownLinks] = useState([])

  const [activeSlug, setActiveSlug] = useState()

  const currentLocation = useLocation()

  const path = currentLocation.pathname.split(/[ /]+/).slice(-1)[0]

  /**
   * Determines the home path based on URL segments and navigation configuration.
   *
   * @param {Object} data - Configuration object
   * @param {Object} data.redirectData - Navigation configuration with regionCodes and directories
   * @param {string} data.path - Full URL path (e.g., "/it/lp/patch-management")
   * @returns {string} Home path - either redirectTo URL, rootPage URL, or "/" as fallback
   *
   * @example
   * getHomePath({
   *   redirectData: {
   *     regionCodes: ["eu", "us", "uk", "au", "ca", "in", "sg"],
   *     directories: {
   *       "it": {
   *         "redirectTo": "/it",
   *         "rootPage": "/it"
   *       }
   *     }
   *   },
   *   path: "/it/lp/patch-management"
   * }) // Returns "/it" (redirectTo) if additional path segments exist, otherwise rootPage
   */
  const getHomePath = useCallback(data => {
    const defaultRegionCodes = ["eu"]
    const { redirectData, path } = data

    const paths = path.split("/").slice(1)

    const regionCodes = redirectData?.["regionCodes"] || defaultRegionCodes
    const subDirectories = redirectData?.["directories"]

    if (!subDirectories || paths.length === 0) return "/"

    let languageSegmentIndex = 0

    if (Array.isArray(regionCodes) && regionCodes.length > 0) {
      const firstSegment = paths[0]?.toLowerCase()
      if (firstSegment && regionCodes.includes(firstSegment)) {
        languageSegmentIndex = 1
      }
    }

    const languageSegment = paths[languageSegmentIndex]

    if (!languageSegment || !subDirectories[languageSegment]) return "/"

    const subDirectoryConfig = subDirectories[languageSegment]

    if (
      subDirectoryConfig.redirectTo &&
      paths.length > languageSegmentIndex + 1
    ) {
      return subDirectoryConfig.redirectTo
    }

    return subDirectoryConfig.rootPage
  }, [])

  const homePath = useMemo(() => {
    const path = currentLocation.pathname

    const redirectData = data.SuperOps.navigationBlocks.filter(
      x => x.version === "subDirectories"
    )?.[0]?.subDirectories

    const res = getHomePath({ redirectData, path })
    return res
  }, [currentLocation])

  useEffect(() => {
    setActiveSlug(
      path === "season1"
        ? "Season 1"
        : path === "season2"
          ? "Season 2"
          : path === "superpod-bytes"
            ? "Superpod Bytes"
            : "Limited Edition"
    )
  }, [path])

  // const closeToggle = () => {
  //   document.querySelector(".navbar-toggler").click()
  // }

  // const [showDiv, setShowDiv] = useState(false)
  // const [idCheck, setIdCheck] = useState(-1)

  // const [animeClass, setAnimeClass] = useState(false)
  // const [animeDir, setAnimeDir] = useState("LtoR")

  // const [navWidth, setNavWidth] = useState("")

  // const handleDskDropdown = (isDropdown, name, index, link) => {
  //   setTimeout(() => {
  //     setAnimeClass(true)
  //   }, 30)

  //   if (link && link.slug && link.slug === "half") {
  //     setNavWidth(false)
  //     setShowDiv(!showDiv)
  //   } else setNavWidth(true)

  //   if (index === idCheck) {
  //     setShowDiv(!showDiv)
  //     setIdCheck(-1)
  //   } else {
  //     setShowDiv(true)

  //     if (idCheck === -1) {
  //       setDropDownLinks(link)
  //       setAnimeDir("LtoR")
  //     } else {
  //       setTimeout(() => {
  //         setDropDownLinks(link)
  //       }, 30)

  //       if (index > idCheck) {
  //         setAnimeDir("RtoL")
  //       } else {
  //         setAnimeDir("LtoR")
  //       }
  //     }

  //     setAnimeClass(false)
  //     setIdCheck(index)
  //   }

  //   setCurrentNav(name !== currentNav && name)
  //   setShowDropdown(
  //     isDropdown === "Yes" && name !== currentNav ? true : !showDropdown
  //   )
  //   setActiveSlug(
  //     path === "season1"
  //       ? "Season 1"
  //       : path === "season2"
  //       ? "Season 2"
  //       : path === "superpod-bytes"
  //       ? "Superpod Bytes"
  //       : "Limited Edition"
  //   )
  // }

  const handleDskDropdownMob = (isDropdown, name, i) => {
    setCurrentNavMob(name !== currentNavMob && name)
    setShowDropdownMob(name)
    setShowDropdownMob(
      isDropdown === "Yes" && name !== currentNavMob ? true : !showDropdownMob
    )
  }

  useEffect(() => {
    document.addEventListener("click", evt => {
      const flyoutElement = document.getElementById("drp-nav")
      let targetElement = evt.target

      do {
        if (targetElement === flyoutElement) {
          return
        }

        targetElement = targetElement.parentNode
      } while (targetElement)

      setShowDropdown(false)
      // setShowDiv(false)
      // setIdCheck("")
      setCurrentNav("")
    })

    window.addEventListener(
      "scroll",
      function () {
        setScrolledDown(window.pageYOffset > (props.dskScroll || 750))
        setScrollMob(window.pageYOffset > props.mobScroll)
      },
      false
    )

    window.addEventListener(
      "scroll",
      function () {
        setHideLogo(window.pageYOffset > 112)
      },
      false
    )

    document.onkeydown = function (evt) {
      if (evt.key === "Escape") {
        setShowDropdown(false)
        setCurrentNav("")
      }
    }
  })

  useEffect(() => {
    axios.get(process.env.IP_STACK_API).then(function (response) {
      if (typeof window.Intercom !== "undefined") {
        window.Intercom("boot", {
          Country: response.data.country_name,
          continent: response.data.continent_name,
          continent_code: response.data.continent_code,
          country_code: response.data.country_code,
          state: response.data.region_name,
          city: response.data.city,
          zip: response.data.zip,
          country_phone_code: response.data.location.calling_code,
        })
      }
    })
  }, [])

  const [activeDropdown, setActiveDropdown] = useState(null)

  return (
    <header
      className={`header-tag ${navType === "only-spsLogo" ? "top-zero" : ""} ${props.isLandingPage ? "tag-t-0" : ""
        }`}
    >
      <Helmet>
        <body
          className={`sticky-navbar ${isNavOpen ? "ofy-hidden" : ""} ${isHelloBarOneVisible || isHelloBarTwoVisible
              ? "hello-bar-visible"
              : ""
            }`}
        />
      </Helmet>
      <HelloBar
        isHelloBarVisible={val => setIsHelloBarOneVisible(val)}
        style={{
          background: !showDropdown && !isScrolledDown && props.color,
        }}
        query='first'
        className={`${!isHelloBarOneVisible ? "closed" : ""
          } ${props.darkHelloBar && "hello-bar-dark"}`}
      />
      {/* <HelloBar
            isHelloBarVisible={val => setIsHelloBarTwoVisible(val)}
            style={{
              background: !showDropdown && !isScrolledDown && props.color,
            }}
            query="second"
            className={`${
              !isHelloBarTwoVisible ? "closed" : ""
            } ${props.darkHelloBar && "hello-bar-dark"}`}
          /> */}
      {navType === "double-nav" && (
        <div className={`brand-nav-container double-nav-container`}>
          {/* NAVBAR DESKTOP */}
          <Navbar
            expand='lg'
            className={`desktop-version delay-trans align-items-center
                                  ${props.navClassName}
                  `}
            style={{
              background: !showDropdown && !isScrolledDown && props.color,
            }}
            id='drp-nav'
          >
            <div className='Layout-container-big d-flex position-relative'>
              <div className={`navbar-left d-flex align-items-center`}>
                <Link to={homePath} className={`navbar-logo`}>
                  <LogoDark className='objcvr' />
                </Link>
              </div>

              <div id='nav_right' className='navbar-right w-100'>

                {/* <div
                  id='nav_top'
                  className={`navbar-top d-flex justify-content-between align-items-end ${
                    props.isLandingPage ? "d-none" : ""
                  }`}
                >
                  <div className='nav-container'>
                    <div className='d-flex gap-24'>
                      {data.SuperOps.navigationBlocks
                        .filter(x => x.version === "V4")
                        .sort((a, b) => a.order - b.order)
                        .map((link, i) => {
                          return (
                            <>
                              <div className='navigation-new Navigation'>
                                {link.isDropdown !== "Yes" && (
                                  <Link
                                    to={`${link.slug}`}
                                    target={
                                      CheckLinkDomain(link.slug)
                                        ? "_self"
                                        : "_blank"
                                    }
                                  >
                                    <p
                                      className={`fw-600 text font-white p12 m-0 navbar-link`}
                                    >
                                      {link.name}
                                      {link.iconType ? (
                                        link.iconType === "Star" && (
                                          <AiStarWhite className='star-icon' />
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </p>
                                  </Link>
                                )}
                              </div>
                            </>
                          )
                        })}
                    </div>
                  </div>

                  <div className='d-flex'>
                    <p className='font-white text fw-600 p12 m-0'>
                      Contact us: +1 628-270-9924 | +44 20 4525 2090
                    </p>
                  </div>
                </div> */}

                <div
                  id='nav_bottom'
                  className='navbar-bottom d-flex align-items-center justify-content-end'
                >
                  {!props.isLandingPage && (
                    <div
                      className={`link-btn-wrapper d-flex align-items-center `}
                    >
                      {data.SuperOps.navigationBlocks
                        .filter(x => x.version === "V5")
                        .sort((a, b) => a.order - b.order)
                        .map((link, i) => {
                          return (
                            <>
                              <div className='navigation-new'>
                                {link.isDropdown === "Yes" && (
                                  <>
                                    <button
                                      className={`navbar-dropdown-button ${smallDropdowns?.includes(link?.name)
                                          ? "position-relative"
                                          : ""
                                        } drpdown-hover 
                                        ${activeDropdown === link.name
                                          ? "is-hovered"
                                          : ""
                                        }
                                        `}
                                      onMouseEnter={() =>
                                        setActiveDropdown(link.name)
                                      }
                                      onMouseLeave={() =>
                                        setActiveDropdown(null)
                                      }
                                    >
                                      {" "}
                                      <p
                                        className={`nav-link-pad fw-600 text font-white m-0`}
                                      >
                                        {link.name}
                                        <SVGIcon
                                          name={"nav-arrow-down-white"}
                                          className={`arrow`}
                                        />
                                      </p>
                                      <div
                                        className={`dropdown-div left-0 ${activeDropdown === link.name
                                            ? ""
                                            : "dspnone"
                                          } ${smallDropdowns?.includes(link?.name)
                                            ? "parent-center"
                                            : "page-center"
                                          }`}
                                      >
                                        <div className='nav-toggle-tracker'>
                                          <NavbarDropdown data={link} />
                                        </div>
                                      </div>
                                    </button>
                                  </>
                                )}
                                {link.isDropdown !== "Yes" && (
                                  <Link to={`${link.slug}`} className=''>
                                    <p
                                      className={`fw-600 text font-white m-0 navbar-link`}
                                    >
                                      {link.name}
                                      {link.iconType ? (
                                        link.iconType === "Star" && (
                                          <AiStarWhite className='star-icon' />
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </p>
                                  </Link>
                                )}
                              </div>
                            </>
                          )
                        })}
                    </div>
                  )}

                  {props.scrollTabs?.length && (
                    <div className='scroll-link d-dsk'>
                      {props.scrollTabs.map(item => {
                        return (
                          <ScrollLink
                            to={item.id}
                            className='scroll-tab'
                            smooth
                            duration={500}
                            key={item.id}
                          >
                            {item.name}
                          </ScrollLink>
                        )
                      })}
                    </div>
                  )}

                  <div className='d-flex'>
                    <Buttons
                      theme={`secondary white br-47 sm navbar-button`}
                      popupDemo={props.popupDemo}
                      text='BOOK A DEMO'
                      link={props.popupDemo ? false : "/demo"}
                    />
                    {props.signupPopup ? (
                      <Buttons
                        theme={`primary${props.newButton ? "-new" : ""
                          } sm navbar-button white ml-9 br-47`}
                        arrowColor={"#ffffff"}
                        text={
                          props.primaryButtonText
                            ? props.primaryButtonText
                            : "GET STARTED FOR FREE"
                        }
                        signupPopup
                        disallowCommonDomains={props.disallowCommonDomains}
                      />
                    ) : (
                      <Buttons
                        theme={`primary white ml-9 br-47 sm navbar-button`}
                        text={
                          props.primaryButtonText
                            ? props.primaryButtonText
                            : "GET STARTED FOR FREE"
                        }
                        link='/signup'
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Navbar>

          {/* NAVBAR DESKTOP END*/}

          {/* NAVBAR MOB */}
          <Navbar
            expand='lg'
            className={`mobile-version brand-nav-light brand-nav-light-mob ${props.navClassName} 
                 `}
            style={{
              background: !isNavOpen && !isScrolledDown && props.color,
            }}
          >
            <div
              className='wrap'
              style={{
                background: !isNavOpen && !isScrolledDown && props.color,
              }}
            >
              <div
                className={`sps-ham d-flex align-items-center light bg-dark-black`}
              >
                <Container className='Layout-container-big'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <Link to={homePath} className={`logo navbar-brand`}>
                      <LogoDark className='objcvr superops-logo' />
                    </Link>
                    <Navbar.Toggle
                      className={`white-ham ${props.isLandingPage ? "d-none" : ""
                        }`}
                      aria-controls='basic-navbar-nav'
                      onClick={() => setIsNavOpen(!isNavOpen)}
                    />
                  </div>
                </Container>
              </div>
              <Navbar.Collapse id='basic-navbar-nav brand-nav-scroll'>
                <Container className='drp-down-parent Layout-container-big'>
                  <Nav className='mr-auto'>
                    {data.SuperOps.navigationBlocks
                      .filter(x => x.version === "V5")
                      .sort((a, b) => a.order - b.order)
                      .map((link, i) => {
                        return (
                          <div className='navigation-new'>
                            <div key={i} className='item-parent'>
                              {link.isDropdown === "Yes" && (
                                <>
                                  <NavDropdown
                                    className='nav-dropdown'
                                    onClick={() =>
                                      handleDskDropdownMob(
                                        link.isDropdown,
                                        link.name,
                                        i,
                                        setDropDownLinks(link)
                                      )
                                    }
                                    title={
                                      <div
                                        className={`nav-link-drp nav-link ${currentNavMob ===
                                          link.name && "active"}`}
                                      >
                                        <div
                                          className={`d-flex justify-content-between align-items-center`}
                                        >
                                          {link.name}
                                          <ArrowDownMob className='arrow home' />
                                        </div>
                                      </div>
                                    }
                                  >
                                    <SlideDown>
                                      <NavbarDropdownMobile
                                        data={dropDownLinks}
                                      />
                                    </SlideDown>
                                  </NavDropdown>
                                </>
                              )}

                              {link.isDropdown !== "Yes" && (
                                <Link
                                  to={`${link.slug}`}
                                  className={`nav-link-mb nav-link`}
                                  style={{ padding: "20px 0" }}
                                >
                                  {link.name}
                                  {link.iconType ? (
                                    link.iconType === "Star" && (
                                      <AiStar className='star-icon' />
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </Link>
                              )}
                            </div>
                          </div>
                        )
                      })}
                    <div className='nav-beta-link'>
                      <div className='cta-w-in'>
                        {props.signupPopup ? (
                          <Buttons
                            theme={`primary${props.newButton ? "-new" : ""
                              } w-100 br-47`}
                            arrowColor={"#ffffff"}
                            text={
                              props.primaryButtonText
                                ? props.primaryButtonText
                                : "GET STARTED FOR FREE"
                            }
                            signupPopup
                          />
                        ) : (
                          <Buttons
                            theme={`primary-new w-100 br-47`}
                            text={
                              props.primaryButtonText
                                ? props.primaryButtonText
                                : "GET STARTED FOR FREE"
                            }
                            link='/signup'
                          />
                        )}
                        <Buttons
                          theme={`secondary-new mt-3 br-47 w-100 demo-btn-left`}
                          text='BOOK A DEMO'
                          link='/demo'
                        />
                      </div>
                    </div>
                  </Nav>
                </Container>
              </Navbar.Collapse>
            </div>
          </Navbar>
          {/* NAVBAR MOB END */}
        </div>
      )}

      {navType === "only-spsLogo" && (
        <Navbar expand='lg' className={`brand-nav-light`}>
          <div
            className={`sps-ham d-flex align-items-center w-100 light bg-dark-black`}
          >
            <Container className='Layout-container-big'>
              <div className='d-flex align-items-center justify-content-between'>
                <Link to='/' className={`logo navbar-brand`}>
                  <LogoDark className='objcvr superops-logo' />
                </Link>
              </div>
            </Container>
          </div>
        </Navbar>
      )}
    </header>
  )
}

export default memo(DoubleNavbar)
